export default __webpack_public_path__ + "static/media/pot1-big.41eee6d9.jpg";